import { FieldActionOnValuesFunction } from '../types';
import { WithdrawDeclarationModel } from '../../api/models/withdrawApplication';
import { standardTitleOptions } from '../title';

export const withdrawDeclaration: FieldActionOnValuesFunction<WithdrawDeclarationModel> = {
    declarantTitle: standardTitleOptions,
};
